import React from "react";
import { useParams, Link } from "react-router-dom";
import styles from "./FullBlogPost.module.css";

function FullBlogPost({ posts }) {
  const { id } = useParams();
  const postIdNumber = parseInt(id);
  const post = posts.find((p) => p.id === postIdNumber);

  if (!post) {
    return (
      <div className={styles.container} style={{ textAlign: "center" }}>
        <h2>404 - Post Not Found</h2>
        <Link to="/" className={styles.backLink}>
          Go back to the Blog List
        </Link>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <img src={post.imageUrl} alt={post.title} className={styles.image} />
      <h1 className={styles.title}>{post.title}</h1>
      <p className={styles.meta}>
        By **{post.author}** | Published on **{post.date}**
      </p>

      <div className={styles.content}>
        <div dangerouslySetInnerHTML={{ __html: post.content }} />
      </div>

      <Link to="/" className={styles.backLink}>
        &larr; Back to all posts
      </Link>
    </div>
  );
}

export default FullBlogPost;
